import { render, staticRenderFns } from "./SearchSelectBox.vue?vue&type=template&id=54cc07e9&"
import script from "./SearchSelectBox.vue?vue&type=script&lang=js&"
export * from "./SearchSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports